import { PermissionGate } from "@components/PermissionGate";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, Group, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEye, IconPencil, IconPlus } from "@tabler/icons-react";

import { AddModal } from "@pages/Patients/Medication/components/AddModal";

import { FilePreviewModal } from "@components/FilePreviewModal";
import { LastUpdatedTimestamp } from "@components/LastUpdated";

import { useAuth } from "@contexts/auth";

import { Prescription } from "@customTypes/prescription";

import { EditModal } from "../EditModal";


interface TableControlsProps {
  prescription: Partial<Prescription>;
}

export const TableControls = ({ prescription }: TableControlsProps) => {
  const { t } = useTranslation();

  const { token } = useAuth();
  const navigate = useNavigate();

  const [
    filePreviewOpened,
    { open: filePreviewOpen, close: filePreviewClose },
  ] = useDisclosure(false);
  const [editModalOpened, { open: editModalOpen, close: editModalClose }] =
    useDisclosure(false);
  const [addModalOpened, { open: addModalOpen, close: addModalClose }] =
    useDisclosure(false);
  const [prescriptionState, setPrescriptionState] =
    useState<Partial<Prescription> | null>(null);

  useEffect(() => {
    // console.log(row.original);
    if (prescription) {
      setPrescriptionState(prescription);
    }
  }, [prescription]);

  return (
    <>
      <FilePreviewModal
        opened={filePreviewOpened}
        close={filePreviewClose}
        docs={
          prescriptionState?.files
            ? [
                ...prescriptionState.files.map(item => ({
                  uri: "https://" + item + `?token=${token}`,
                  fileName: (item as string).split("/files/")[1],
                })),
              ]
            : []
        }
      />
      <EditModal
        opened={editModalOpened}
        close={editModalClose}
        prescription={prescription}
      />
      <AddModal
        opened={addModalOpened}
        close={addModalClose}
        prescriptionId={prescriptionState?.id ?? ""}
        cId={prescriptionState?.consultationInfo?.cId ?? ""}
      />

      <Group className="table-controls" justify="end">
        <Menu withArrow position="bottom-end" withinPortal>
          <Menu.Target>
            <Button variant="outline" size="compact-sm">
              {t("action")}
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>{t("prescription")}</Menu.Label>
            <Menu.Item
              disabled={
                prescriptionState?.files && prescriptionState.files.length > 0
                  ? false
                  : true
              }
              leftSection={<IconEye size={16} stroke={1.5} />}
              onClick={filePreviewOpen}>
              {t("view-files")}
            </Menu.Item>

            <PermissionGate permission="prescriptions.edit"><Menu.Item
              leftSection={<IconPencil size={16} stroke={1.5} />}
              onClick={() => {
                editModalOpen();
              }}>
              {t("edit-prescription")}
            </Menu.Item></PermissionGate>
            <Menu.Divider />
            <Menu.Label>{t("medication")}</Menu.Label>
            <PermissionGate permission="medications.view"><Menu.Item
              leftSection={<IconEye size={16} stroke={1.5} />}
              onClick={() => {
                navigate(`${prescriptionState?.id}/medication`, {
                  state: { selectedPrescription: prescriptionState },
                });
              }}>
              {t("view-medications")}
            </Menu.Item></PermissionGate>
            <PermissionGate permission="medications.create"><Menu.Item
              leftSection={<IconPlus size={16} stroke={1.5} />}
              onClick={() => {
                addModalOpen();
              }}>
              {t("add-medication")}
            </Menu.Item></PermissionGate>
            {/* <Menu.Item
              leftSection={<IconTrash size={16} stroke={1.5} />}
              color="red"
              onClick={() =>
                openDeleteModal({
                  onConfirm: () =>
                    deletePrescription({
                      prescriptionId: prescriptionState?.id as string,
                    }),
                })
              }>
              Delete prescription
            </Menu.Item> */}
          </Menu.Dropdown>
        </Menu>
      </Group>

      <LastUpdatedTimestamp
        updatedDate={prescription?.updatedAt as Date}
        className="last-updated"
      />
    </>
  );
};
